import $ from "jquery";

// TODO: Update dumbcrossfade
require("../vendor/jquery.dumbcrossfade");

export class ModSlideshow {
  constructor() {
    var $window = $(window),
      $moduleContainer,
      $slideshow,
      $moduleContainer = $(".fw_fContainer_module"),
      $slideshow = $moduleContainer.find(".fw_Slideshow"),
      $slideshowOptions = $moduleContainer.find(".fw_txt_options");
      $slideshow.css("display", "none");
      $(".s_a_text_options a:first").addClass("optionSelected");
    var options = {
      slideChange: function(currentSlideIndex) {
        $(".fw_txt_options a").removeClass("optionSelected");
        $(".fw_txt_options a:eq(" + currentSlideIndex + ")").addClass(
          "optionSelected"
        );
      },
      slideType: "fade",
      showTime: 8000
    };
    var slidefw_fContainershow = $slideshow.dumbCrossFade(options);
    var i = 0;
    var j = 1;

    $("#previousfw_fContainerbutton").click(function() {
      $slideshow.dumbCrossFade("previous");
      return false;
    });

    $("#nextfw_fContainerbutton").click(function() {
      $slideshow.dumbCrossFade("next");
      return false;
    });

    $slideshow.first().addClass("activeS");

    $slideshow.each(function() {
      $(".fw_txt_options").append(
        '<li class=" test fw_txt_option"><a href=""  id="btn' +
          j +
          '" class="button">' +
          j +
          "</a></li>"
      );

      j++;
    });

    $(".fw_txt_options a").each(function() {
      $(this).attr("href", i + "");
      i++;
    });

    $(".fw_txt_options a").click(function() {
      $slideshow.dumbCrossFade("jump", parseInt($(this).attr("href")));
      return false;
    });

    $slideshowOptions
      .first(".fw_txt_option")
      .find("a")
      .addClass("optionSelected");

    $moduleContainer.removeClass("invisible");
  }
}
